import React from 'react';
import { Card, LoadingSpinner } from 'components/common';
import { FiTrendingUp, FiFolder, FiBarChart2 } from 'react-icons/fi';
import PropTypes from 'prop-types';

const getErrorMessage = (error) => {
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && error.error) return error.error;
  return 'An error occurred';
};

const MetricsGrid = ({ summary, loading, error }) => {
  const metrics = [
    {
      id: 'total_cos',
      label: 'Total Change Orders',
      value: summary?.total_change_orders || 0,
      icon: FiTrendingUp,
      color: 'tw-bg-blue-50 tw-text-blue-600'
    },
    {
      id: 'total_projects',
      label: 'Total Projects',
      value: summary?.total_projects || 0,
      icon: FiFolder,
      color: 'tw-bg-green-50 tw-text-green-600'
    },
    {
      id: 'avg_co',
      label: 'Avg CO per Project',
      value: (summary?.average_co_per_project || 0).toFixed(2),
      icon: FiBarChart2,
      color: 'tw-bg-red-50 tw-text-red-600'
    },
    {
      id: 'shop_drawings',
      label: 'Shop Drawings',
      value: summary?.shop_drawing_count || 0,
      icon: FiTrendingUp,
      color: 'tw-bg-primary-50 tw-text-primary-600'
    }
  ];

  if (loading) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-py-12">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <Card className="tw-bg-red-50 tw-border tw-border-red-200 tw-p-6">
        <p className="tw-text-red-600 tw-font-semibold">Error loading metrics</p>
        <p className="tw-text-red-500 tw-text-sm">{getErrorMessage(error)}</p>
      </Card>
    );
  }

  return (
    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-6">
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <Card
            key={metric.id}
            className="tw-flex tw-flex-col tw-gap-4 tw-p-6 tw-border tw-border-gray-200 hover:tw-shadow-lg tw-transition-shadow"
          >
            <div className="tw-flex tw-items-center tw-justify-between">
              <div>
                <p className="tw-text-gray-600 tw-text-sm tw-font-medium">
                  {metric.label}
                </p>
                <p className="tw-text-3xl tw-font-bold tw-text-gray-900 tw-mt-2">
                  {metric.value}
                </p>
              </div>
              <div className={`tw-rounded tw-p-3 ${metric.color}`}>
                <Icon size={24} />
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

MetricsGrid.propTypes = {
  summary: PropTypes.shape({
    total_change_orders: PropTypes.number,
    total_projects: PropTypes.number,
    p_type_count: PropTypes.number,
    j_type_count: PropTypes.number,
    average_co_per_project: PropTypes.number,
    shop_drawing_count: PropTypes.number
  }),
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

MetricsGrid.defaultProps = {
  summary: {},
  loading: false,
  error: null
};

export default MetricsGrid;
